import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'

import { LectureApiBase } from './lecture-api'
import { Lecture } from '../models/lecture'
import { PaginatedList } from '../libs/infinite-paginator'

@Injectable()
export class LectureApi {
  private apiPath = 'lectures'

  constructor(
    private api: LectureApiBase,
  ) {}

  index(): PaginatedList<Lecture> {
    return this.api.listWithPaginate<Lecture>(Lecture, this.apiPath)
  }

  children(id: number): PaginatedList<Lecture> {
    return this.api.listWithPaginate<Lecture>(Lecture, `${this.apiPath}/${id}/children`)
  }

  create_child(id:number, params: any): Observable<Lecture> {
    return this.api.postWithObject(Lecture, `${this.apiPath}/${id}/children`, params)
  }

  get(id: number): Observable<Lecture> {
    return this.api.getWithObject(Lecture, `${this.apiPath}/${id}`)
  }

  update(id: number, params: any): Observable<Lecture> {
    return this.api.putWithObject(Lecture, `${this.apiPath}/${id}`, params)
  }

  create(params: any): Observable<Lecture> {
    return this.api.postWithObject(Lecture, this.apiPath, params)
  }
}



// WEBPACK FOOTER //
// ./src/apis/lecture.ts